exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".switcherIntro-4b42479a{margin-bottom:20px}.switcherIntro-4b42479a .firstMsg-83644413{padding-bottom:10px}.twoCol-6a61aa2f{display:flex;width:100%}.twoCol-6a61aa2f>div{flex:1 1 50%}.twoCol-6a61aa2f>div:first-child{padding-right:8px}.twoCol-6a61aa2f>div:last-child{padding-left:8px}.inlineCB-370a9c1a{display:flex;align-items:center;padding-top:12px}.inlineCB-370a9c1a .cbInline-ca872725{margin-left:14px;margin-bottom:5px}.FlagButton-e2f3fc63{display:flex;justify-content:space-between}.FlagButton-e2f3fc63 .flag-90c0de8c{display:flex;align-items:center}.FlagButton-e2f3fc63 .flag-90c0de8c img{margin-top:0}.FlagButton-e2f3fc63 .flag-90c0de8c .spacer-652543bd{padding:0px 5px}\n", ""]);

// Exports
exports.locals = {
	"switcherIntro": "switcherIntro-4b42479a",
	"firstMsg": "firstMsg-83644413",
	"twoCol": "twoCol-6a61aa2f",
	"inlineCB": "inlineCB-370a9c1a",
	"cbInline": "cbInline-ca872725",
	"FlagButton": "FlagButton-e2f3fc63",
	"flag": "flag-90c0de8c",
	"spacer": "spacer-652543bd"
};